import styled from 'styled-components';

export const RentContractStyles = styled.div`
  padding: 43px 0 100px;
  flex-grow: 1;
  
  color: #FFF;
  background: #1B1F2C;
  
  .container {
    display: grid;
    gap: 32px;
    
    &.firstContainer {
      margin-bottom: 100px;
      
      @media (max-width: 500px) {
        margin-bottom: 54px;
      }
    }
  }
  
  .rightSideTitle {
    text-align: right;
    
    h3 {
      margin-bottom: 2px;
    }
  }
  
  h1, h3 {
    color: #FFC228;
  }
  
  a {
    text-decoration: underline;
  }

  .titleWrapper {
    h1 {
      margin-bottom: 16px;
    }
    
    p {
      margin-bottom: 12px;
    }
    
    .headWrapper {
      text-align: center;
      margin-bottom: 16px;
      
      h2 {
        color: #FFC228;
      }
    }
  }
  
  .listWrapper {
    display: grid;
    gap: 16px;
    
    
    .textContainer {
      display: grid;
      gap: 12px;
      
      .listContainer {
        display: grid;
        gap: 8px;
        
        ul {
          display: grid;
          gap: 8px;
        }
      }
    }
    
    .list {
      display: grid;
      gap: 12px;
      box-sizing: border-box;
      
      .innerList {
        display: grid;
        gap: 8px;
        
        padding-left: 24px;
        box-sizing: border-box;
        
        @media (max-width: 360px) {
          max-width: 288px;
        } 
        
        @media (max-width: 500px) {
          padding-left: 16px;
        }
      }
    }
  }
`;
